import script from "./DashboardMain.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardMain.vue?vue&type=script&setup=true&lang=js"

import "./DashboardMain.vue?vue&type=style&index=0&id=627c0822&lang=css"

const __exports__ = script;

export default __exports__